import { render } from "./Report.vue?vue&type=template&id=d5b1bd76&scoped=true"
import script from "./Report.vue?vue&type=script&lang=ts"
export * from "./Report.vue?vue&type=script&lang=ts"

import "./Report.vue?vue&type=style&index=0&id=d5b1bd76&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d5b1bd76"

export default script